<section class="child">
    <nav>
        <c-tree-explorer config="shortcutsConfig"></c-tree-explorer>
    </nav>
</section>